import React from 'react';
import { useTranslation } from 'react-i18next';
import StandardMenu from '../../../../Dropdown/MenuPreset/StandardMenu';
import { BiEventType } from '../../../../biLogger/constants';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../_partials/hooks/useDeviationAttributes';
import s from './MoreMenuContent.scss';
// This is used only on desktop
var MoreMenuContent = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, _b = _a.closeTooltip, closeTooltip = _b === void 0 ? function () { return null; } : _b, showReportModal = _a.showReportModal, showDesktopDeviationSharePopup = _a.showDesktopDeviationSharePopup;
    var t = useTranslation().t;
    var _c = useDeviationAttributes(deviation, isOwner), isShareable = _c.isShareable, isReportable = _c.isReportable;
    return (React.createElement(StandardMenu, { className: s['menu'], id: "actionbar-more-menu", items: [
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: {
                    evid: BiEventType.CLICK_SHARE,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                },
                onClick: function () {
                    showDesktopDeviationSharePopup();
                },
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: {
                    evid: BiEventType.CLICK_REPORT_BUTTON,
                    modal_version: 2,
                },
                onClick: function () {
                    showReportModal(deviation);
                    closeTooltip();
                },
            },
        ] }));
};
MoreMenuContent.displayName = 'MoreMenuContent';
export default MoreMenuContent;
//# sourceMappingURL=MoreMenuContent.core_badges.js.map